import { createAction } from 'redux-actions';

import * as ACTION from './constants';

export const getDetail = createAction(ACTION.GET_DETAIL.REQUEST);

export const setDetail = createAction(ACTION.SET_DETAIL);

export const clearState = createAction(ACTION.CLEAR_STATE);
